export const addSizeQuery = (imageSource, width, height) => {
    if (!imageSource) {
        return null;
    }
    const hasQuery = imageSource.includes("?");
    if (hasQuery) {
        return imageSource;
    }
    if (width && height)
        return `${imageSource}?w=${width}&h=${height}`;
    return `${imageSource}?w=${width}`;
};
